import httpClient from "api/httpClient";

const getContractsStats = (params?: Record<string, any>) =>
  httpClient.get(`admin/contracts/stats`, { params });

export default { getContractsStats };
